import React, { ReactNode } from 'react';
import { useUser } from '../contexts/UserContext';
import PrivateBetaPage from '../pages/PrivateBetaPage';
import { getEngineAccessMode, shouldBlockEngineRoute } from '../utils/engineAccess';

interface EngineAccessGuardProps {
  children: ReactNode;
}

const EngineAccessGuard: React.FC<EngineAccessGuardProps> = ({ children }) => {
  const { user, loading } = useUser();
  const mode = getEngineAccessMode();

  if (shouldBlockEngineRoute(mode, user, loading)) {
    return <PrivateBetaPage />;
  }

  return <>{children}</>;
};

export default EngineAccessGuard;
